export const ASSET_EXPLORE_GET_DATA = 'ASSET_EXPLORE_GET_DATA'
export const ASSET_EXPLORE_GET_DATA_SUCCESS = 'ASSET_EXPLORE_GET_DATA_SUCCESS'
export const ASSET_EXPLORE_GET_DATA_FAILURE = 'ASSET_EXPLORE_GET_DATA_FAILURE'
export const ASSET_EXPLORE_EMPTY = 'ASSET_EXPLORE_EMPTY'

export const ASSET_EXPLORE_ADD = 'ASSET_EXPLORE_ADD'

export const ASSET_DELETE = 'ASSET_DELETE'
export const ASSET_DELETE_SUCCESS = 'ASSET_DELETE_SUCCESS'
export const ASSET_DELETE_FAILURE = 'ASSET_DELETE_FAILURE'

export const ASSET_EXPLORE_SET_SELECT = 'ASSET_EXPLORE_SET_SELECT'
export const ASSET_EXPLORE_UNSET_SELECT = 'ASSET_EXPLORE_UNSET_SELECT'

export const ASSET_EXPLORE_ACTIVEVIEW = 'ASSET_EXPLORE_ACTIVEVIEW'

export const ASSET_EXPLORE_EDIT_SELECT = 'ASSET_EXPLORE_EDIT_SELECT'
export const ASSET_EXPLORE_EDIT_UNSET_SELECT = 'ASSET_EXPLORE_EDIT_UNSET_SELECT'
export const ASSET_EXPLORE_EDIT = 'ASSET_EXPLORE_EDIT'
export const ASSET_EXPLORE_EDIT_SUCCESS = 'ASSET_EXPLORE_EDIT_SUCCESS'
export const ASSET_EXPLORE_EDIT_FAILURE = 'ASSET_EXPLORE_EDIT_FAILURE'

export const ASSET_EXPLORE_EXPAND_SELECT = 'ASSET_EXPLORE_EXPAND_SELECT'
export const ASSET_EXPLORE_EXPAND_UNSET_SELECT = 'ASSET_EXPLORE_EXPAND_UNSET_SELECT'

export const ASSET_EXPLORE_SHARE_SELECT = 'ASSET_EXPLORE_SHARE_SELECT'
export const ASSET_EXPLORE_SHARE_UNSET_SELECT = 'ASSET_EXPLORE_SHARE_UNSET_SELECT'

export const ASSET_EXPLORE_DELETE = 'ASSET_EXPLORE_DELETE'
export const ASSET_EXPLORE_DELETE_SUCCESS = 'ASSET_EXPLORE_DELETE_SUCCESS'
export const ASSET_EXPLORE_DELETE_FAILURE = 'ASSET_EXPLORE_DELETE_FAILURE'

export const ASSET_EXPLORE_MOVE = 'ASSET_EXPLORE_MOVE'
export const ASSET_EXPLORE_MOVE_SUCCESS = 'ASSET_EXPLORE_MOVE_SUCCESS'
export const ASSET_EXPLORE_MOVE_FAILURE = 'ASSET_EXPLORE_MOVE_FAILURE'

export const ASSET_EXPLORE_CHECK_SELECT = 'ASSET_EXPLORE_CHECK_SELECT'
export const ASSET_EXPLORE_UNCHECK_SELECT = 'ASSET_EXPLORE_UNCHECK_SELECT'

export const MULTIPLE_EXPLORE_OPTIONS_ACTIVATE = 'MULTIPLE_EXPLORE_OPTIONS_ACTIVATE'
export const MULTIPLE_EXPLORE_OPTIONS_DEACTIVATE = 'MULTIPLE_EXPLORE_OPTIONS_DEACTIVATE'
export const MULTIPLE_EXPLORE_OPTIONS_DONE = 'MULTIPLE_EXPLORE_OPTIONS_DONE'

export const ASSET_EXPLORE_UPDATE_FROM_PERMISSION = 'ASSET_EXPLORE_UPDATE_FROM_PERMISSION'

export const ASSETS_EXPLORE_MULTI_DELETE = 'ASSETS_EXPLORE_MULTI_DELETE'
export const ASSETS_EXPLORE_MULTI_DELETE_SUCCESS = 'ASSETS_EXPLORE_MULTI_DELETE_SUCCESS'
export const ASSETS_EXPLORE_MULTI_DELETE_FAILURE = 'ASSETS_EXPLORE_MULTI_DELETE_FAILURE'

export const ASSETS_EXPLORE_MULTI_MOVE = 'ASSETS_EXPLORE_MULTI_MOVE'
export const ASSETS_EXPLORE_MULTI_MOVE_SUCCESS = 'ASSETS_EXPLORE_MULTI_MOVE_SUCCESS'
export const ASSETS_EXPLORE_MULTI_MOVE_FAILURE = 'ASSETS_EXPLORE_MULTI_MOVE_FAILURE'

export const CLEAN_DATA_BACK_EXPLORE = 'CLEAN_DATA_BACK_EXPLORE'
export const SCROLL_EXPLORE = 'SCROLL_EXPLORE'
